export default __webpack_public_path__ + "static/while-my-heart-is-still-beating-bg-d1d43f8c77d1d01f55a99e2dcd08bb07.svg";